import { render, staticRenderFns } from "./AsideSong.vue?vue&type=template&id=c05e5f76"
import script from "./AsideSong.vue?vue&type=script&lang=js"
export * from "./AsideSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports